import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import LanguageSheet from "./LanguageSheet";

export default function Header({ onCtaClick }) {
  const { lang, t } = useLang();
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#080706]/85 border-b border-gold"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2.5 flex items-center justify-between">
        <Link to={`/${lang}`} className="flex items-center group" data-testid="brand-logo">
          <img src="/logo.png" alt="SHREE RAGO" className="h-10 sm:h-12 w-auto drop-shadow-[0_0_12px_rgba(214,170,69,0.35)] group-hover:drop-shadow-[0_0_18px_rgba(242,210,122,0.55)] transition" />
        </Link>

        <div className="flex items-center gap-3">
          <LanguageSheet />
          <button
            data-testid="header-cta-btn"
            onClick={onCtaClick}
            className="btn-gold text-[11px] sm:text-xs px-4 sm:px-6 py-2.5 hidden sm:block"
          >
            {t("nav.cta")}
          </button>
        </div>
      </div>
    </header>
  );
}
